import React from 'react';
export function BigIdea() {
  return <section aria-labelledby="big-idea-heading" className="w-full bg-sage text-white" data-id="element-24" data-mp="1vstwp7cd25n7">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24" data-id="element-25" data-mp="2p8n9nrs4eilp">
        <h2 id="big-idea-heading" className="font-serif font-bold text-2xl sm:text-4xl lg:text-[44px] lg:leading-[1.1] leading-snug" data-id="element-26" data-mp="2u8ro7c9gx39a">
          The difference between a system you keep and a system you abandon
          isn&apos;t discipline.
          <span className="block mt-3 font-serif italic font-normal text-white/70" data-id="element-27" data-mp="26jgkpn0qgurg">
            It&apos;s the design.
          </span>
        </h2>

        <p className="mt-8 text-white/85 text-base sm:text-lg leading-relaxed max-w-2xl" data-id="element-28" data-mp="2bhruxyuxx7a7">
          Discipline gets you week one. Design gets you week fourteen. A planner
          is a photograph of a perfect week — and you&apos;ve never had one of
          those. This is a thermostat: it adjusts when the week drifts, and it
          restarts when the week dies.{' '}
          <strong className="text-white font-semibold" data-id="element-29" data-mp="2u2ao57gnak3o">
            You never failed those systems. They were built for a life nobody
            actually lives.
          </strong>
        </p>
      </div>
    </section>;
}